/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/ParametricFilters.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/** @hidden */
export const OutputModeValues = ['BINARY', 'ANTIALIASED'];
/** @hidden */
export const BinarizationFilterPresetValues = [
    'PRESET_1',
    'PRESET_2',
    'PRESET_3',
    'PRESET_4',
    'PRESET_5',
];
/** @internal */
export var ParametricFilter;
(function (ParametricFilter) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'LegacyFilter':
                return new LegacyFilter(source);
            case 'ScanbotBinarizationFilter':
                return new ScanbotBinarizationFilter(source);
            case 'CustomBinarizationFilter':
                return new CustomBinarizationFilter(source);
            case 'ColorDocumentFilter':
                return new ColorDocumentFilter(source);
            case 'BrightnessFilter':
                return new BrightnessFilter(source);
            case 'ContrastFilter':
                return new ContrastFilter(source);
            case 'GrayscaleFilter':
                return new GrayscaleFilter(source);
            case 'WhiteBlackPointFilter':
                return new WhiteBlackPointFilter(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    ParametricFilter.from = from;
})(ParametricFilter || (ParametricFilter = {}));
/**
Deprecated. Returns the input image unchanged.
*/
export class LegacyFilter {
    /** @param source {@displayType `DeepPartial<LegacyFilter>`} */
    constructor(source = {}) {
        this._type = 'LegacyFilter';
        /**
          Ignored.
          
          Default is 0
          */
        this.filterType = 0;
        if (source.filterType !== undefined) {
            this.filterType = source.filterType;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            filterType: this.filterType,
        };
    }
}
/**
Automatic binarization filter. This filter is a good starting point for most use cases.
*/
export class ScanbotBinarizationFilter {
    /** @param source {@displayType `DeepPartial<ScanbotBinarizationFilter>`} */
    constructor(source = {}) {
        this._type = 'ScanbotBinarizationFilter';
        /**
          Output mode of the filter. BINARY will return a black and white image, GRAYSCALE will return an antialiased grayscale image.
          
          Default is BINARY
          */
        this.outputMode = 'BINARY';
        if (source.outputMode !== undefined) {
            this.outputMode = source.outputMode;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            outputMode: this.outputMode,
        };
    }
}
/**
Automatic binarization filter. This filter is a good starting point for most use cases.
*/
export class CustomBinarizationFilter {
    /** @param source {@displayType `DeepPartial<CustomBinarizationFilter>`} */
    constructor(source = {}) {
        this._type = 'CustomBinarizationFilter';
        /**
          Output mode of the filter. BINARY will return a black and white image, GRAYSCALE will return an antialiased grayscale image.
          
          Default is BINARY
          */
        this.outputMode = 'BINARY';
        /**
          Value controlling the amount of noise removal. Value between 0 and 1.
          Too little noise removal may result in a very noisy image, worsening readability.
          Too much noise removal may result in the degradation of text, again, worsening readability.
          
          Default is 0.5
          */
        this.denoise = 0.5;
        /**
          Filter radius. The bigger the radius, the slower the filter and generally the less noise in the result.
          The radius is used for both shadows removal and the calculation of local statistics in the main body of the filter.
          Higher radius usually allows to cope better with regions of light text on dark background.
          All the values larger than 127 are clamped to 127.
          
          Default is 32
          */
        this.radius = 32;
        /**
          Preset of binarization filter parameters that are found to perform well on different types of documents.
          
          Default is PRESET_4
          */
        this.preset = 'PRESET_4';
        if (source.outputMode !== undefined) {
            this.outputMode = source.outputMode;
        }
        if (source.denoise !== undefined) {
            this.denoise = source.denoise;
        }
        if (source.radius !== undefined) {
            this.radius = source.radius;
        }
        if (source.preset !== undefined) {
            this.preset = source.preset;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            outputMode: this.outputMode,
            denoise: this.denoise,
            radius: this.radius,
            preset: this.preset,
        };
    }
}
/**
Color document filter. This filter is a good starting point for most use cases.
*/
export class ColorDocumentFilter {
    /** @param source {@displayType `DeepPartial<ColorDocumentFilter>`} */
    constructor(source = {}) {
        this._type = 'ColorDocumentFilter';
        /**
          Strength of contrast enhancement. Typical values are between 0 and 1, although higher values are possible.
          
          Default is 0.5
          */
        this.contrastEnhancement = 0.5;
        /**
          Strength of color saturation enhancement. Typical values are between 0 and 1, although higher values are possible.
          
          Default is 0.5
          */
        this.colorEnhancement = 0.5;
        /**
          Paper whitening strength balances color enhancement and paper color improvement.
          Only relevant if colorEnhancement is above 0. Typical values are between 0 and 2.
          
          Default is 1
          */
        this.paperWhitening = 1.0;
        /**
          Paper whitening bias balances between whitening more of the paper of preserving more of the colors.
          Negative values will preserve more colors, positive values will whiten more of the paper.
          Only relevant if colorEnhancement is above 0. Typical values are between -25 and 25.
          
          Default is 0
          */
        this.paperWhiteningBias = 0;
        if (source.contrastEnhancement !== undefined) {
            this.contrastEnhancement = source.contrastEnhancement;
        }
        if (source.colorEnhancement !== undefined) {
            this.colorEnhancement = source.colorEnhancement;
        }
        if (source.paperWhitening !== undefined) {
            this.paperWhitening = source.paperWhitening;
        }
        if (source.paperWhiteningBias !== undefined) {
            this.paperWhiteningBias = source.paperWhiteningBias;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            contrastEnhancement: this.contrastEnhancement,
            colorEnhancement: this.colorEnhancement,
            paperWhitening: this.paperWhitening,
            paperWhiteningBias: this.paperWhiteningBias,
        };
    }
}
/**
Brightness adjustment filter.
*/
export class BrightnessFilter {
    /** @param source {@displayType `DeepPartial<BrightnessFilter>`} */
    constructor(source = {}) {
        this._type = 'BrightnessFilter';
        /**
          Brightness adjustment value in the range from -1 to 1. Negative values will make the image darker, positive values will make it brighter.
          
          Default is 0.0
          */
        this.brightness = 0.0;
        if (source.brightness !== undefined) {
            this.brightness = source.brightness;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            brightness: this.brightness,
        };
    }
}
/**
Contrast adjustment filter.
*/
export class ContrastFilter {
    /** @param source {@displayType `DeepPartial<ContrastFilter>`} */
    constructor(source = {}) {
        this._type = 'ContrastFilter';
        /**
          Contrast adjustment value in the range from -1 to 254 (inclusively). Negative values will decrease the contrast, positive values will increase it.
          
          Default is 0.0
          */
        this.contrast = 0.0;
        if (source.contrast !== undefined) {
            this.contrast = source.contrast;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            contrast: this.contrast,
        };
    }
}
/**
Converts color images to grayscale and applies autocontrast.
*/
export class GrayscaleFilter {
    /** @param source {@displayType `DeepPartial<GrayscaleFilter>`} */
    constructor(source = {}) {
        this._type = 'GrayscaleFilter';
        /**
          Ignore this fraction of pixels at the edge of the image when calculating statistics.
          Pixels at the edge of the image typically have poor statistics. Ignoring them
          and using only the inner pixels when calculating certain statistics can
          substantially improve the quality of the result.
          The value must be less than 0.5 but usually good values are between 0 and 0.15.
          
          Default is 0.06
          */
        this.borderWidthFraction = 0.06;
        /**
          Clip this fraction of the darkest pixels in operations such as autocontrast.
          Increasing the range of middle gray levels at the expense of the brightest and darkest levels
          may improve the overall contrast and quality of the result.
          Sum of blackOutliersFraction and whiteOutliersFraction must be less than 1 but usually
          good values for the parameters do not exceed 0.05;.
          
          Default is 0.0
          */
        this.blackOutliersFraction = 0.0;
        /**
          Clip this fraction of the brightest pixels in operations such as autocontrast.
          Increasing the range of middle gray levels at the expense of the brightest and darkest levels
          may improve the overall contrast and quality of the result.
          Sum of blackOutliersFraction and whiteOutliersFraction must be less than 1 but usually
          good values for the parameters do not exceed 0.05;.
          
          Default is 0.02
          */
        this.whiteOutliersFraction = 0.02;
        if (source.borderWidthFraction !== undefined) {
            this.borderWidthFraction = source.borderWidthFraction;
        }
        if (source.blackOutliersFraction !== undefined) {
            this.blackOutliersFraction = source.blackOutliersFraction;
        }
        if (source.whiteOutliersFraction !== undefined) {
            this.whiteOutliersFraction = source.whiteOutliersFraction;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            borderWidthFraction: this.borderWidthFraction,
            blackOutliersFraction: this.blackOutliersFraction,
            whiteOutliersFraction: this.whiteOutliersFraction,
        };
    }
}
/**
Maps image value channel so that all the pixels darker than the black point are set to 0,
all the pixels brighter than the white point are set to 255, and the pixels in between
are linearly scaled.
*/
export class WhiteBlackPointFilter {
    /** @param source {@displayType `DeepPartial<WhiteBlackPointFilter>`} */
    constructor(source = {}) {
        this._type = 'WhiteBlackPointFilter';
        /**
          Fraction of the value channel range that is set to 0. The value should be in the range from 0 to 1.
          
          Default is 0.0
          */
        this.blackPoint = 0.0;
        /**
          Fraction of the value channel range that is not set to 255. The value should be in the range from 0 to 1.
          
          Default is 1.0
          */
        this.whitePoint = 1.0;
        if (source.blackPoint !== undefined) {
            this.blackPoint = source.blackPoint;
        }
        if (source.whitePoint !== undefined) {
            this.whitePoint = source.whitePoint;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            blackPoint: this.blackPoint,
            whitePoint: this.whitePoint,
        };
    }
}
/** @hidden */
export const PageBinarizationValues = [
    'DISABLED',
    'ENABLED',
    'ENABLED_IF_BINARIZATION_FILTER_SET',
];
//# sourceMappingURL=ParametricFilters.js.map